import React from 'react'
import ReactDOM from 'react-dom/client'
import { WebCalculator } from './WebCalculator'
import type { CalculatorId } from '@wirecoder/calc'
import '../index.css'

// Each calculator page's HTML carries <div id="calc-root" data-calc="...">.
// One shared entry mounts the right interactive widget; the rest of the page
// (h1, intro, FAQ) is static HTML for crawlers.
const el = document.getElementById('calc-root')
const calcId = el?.dataset.calc as CalculatorId | undefined

if (el && calcId) {
  ReactDOM.createRoot(el).render(
    <React.StrictMode>
      <WebCalculator calcId={calcId} />
    </React.StrictMode>,
  )
}
